import { useEffect, useState } from "react";
import purchase_logo from "assets/images/icons/purchase_logo.png";
import Brands from "components/purchase/Brands";
import Faqs from "components/purchase/Faqs";
import Features from "components/purchase/Features";
import Features2 from "components/purchase/Features2";
import GradientCard from "components/purchase/GradientCard";
import Testimonial from "components/purchase/Testimonial";
import TimeLine from "components/purchase/TimeLine";
import { BlueTickIcon } from "utils/Icons";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setAuth } from "redux/reducers/authReducerSlice";
import axios from "axios";
import firebase from "config/firebase";
import { convertPrice } from "utils/actions";
import { auth } from "config/firebase";

//
const Purchase = () => {
  const { data: user } = useSelector((store) => store.auth);
  const navigate = useNavigate();
  const [purchaseModal, setPurchaseModal] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState("Yearly");
  const [planPrices, setPlanPrices] = useState({
    monthly: 9900,
    yearly: 1499,
    trial_period: 7,
    loading: true,
  });
  const dispatch = useDispatch();

  //
  const [searchParams] = useSearchParams();
  const paramsPromo = searchParams.get("promo");
  // close modal
  const closeModal = () => {
    setPurchaseModal(false);
  };
  // toggle modal
  const toggleModal = () => {
    setPurchaseModal(!purchaseModal);
  };
  //
  const selectAPlan = (id) => {
    setSelectedPlan(id);
  };

  // for chargebee payment
  useEffect(() => {
    //
    let cbInstance;
    //
    cbInstance = window.Chargebee.init({
      site: `${process.env.REACT_APP_CHARGEBEE_SITE}`,
      isItemsModel: true,
      enableFBQTracking: true

    });

    cbInstance = window.Chargebee.getInstance();

    let leadDyno = window.LeadDyno
    let trackingId = leadDyno.devTools.getTrackingId()
    leadDyno.recordLead(user.emailAddress)


    cbInstance.getCart().setAffiliateToken(trackingId);
    var shippingAddress = {
      email: user.emailAddress,
    };

    cbInstance.setCheckoutCallbacks(function (cart) {
      cart.setAffiliateToken(trackingId);
      cart.setCustomer(shippingAddress);
      // you can define custom callbacks based on cart object
      return {
        loaded: function () {},
        close: function () {},
        success: function (hostedPageId) {
          dispatch(
            setAuth({
              isLoading: false,
              isAuthenticated: true,
              data: {
                ...user,
                subscribed: true,
              },
            })
          );
          navigate("/myAccount/home");
        },
        step: function () {},
      };
    });

    var link = document.querySelectorAll("[data-cb-type=checkout]")[0];
    var link1 = document.querySelectorAll("[data-cb-type=checkout]")[1];
    //
    var product = cbInstance.getProduct(link);
    var product1 = cbInstance.getProduct(link1);
    //
    product?.addCoupon(paramsPromo);
    product1?.addCoupon(paramsPromo);

    // get item prices
    firebase
      .auth()
      .currentUser.getIdToken()
      .then(function (idToken) {
        axios({
          method: "GET",
          url: `${process.env.REACT_APP_MAMAZEN_API_BASE_URL}chargebee/item_prices`,
          headers: {
            Authorization: idToken,
            token_type: "firebase",
          },
        })
          .then((response) => {
            let data = response?.data?.list || [];
            let monthlyData = data.find(
              (v) =>
                v?.id === `${process.env.REACT_APP_CHARGEBEE_MONTHLY_PRODUCT}`
            );
            let yearlyData = data.find(
              (v) => {

                let checkId = searchParams.get("sId");


                console.log(`checkId: ${checkId}`)
                let actualId = checkId ? `${checkId}` : `${process.env.REACT_APP_CHARGEBEE_YEARLY_PRODUCT}`
                let result =  v?.item_price?.id === actualId

                return result
              }

            );

            let monthlyPrice = monthlyData?.item_price?.price || 1999

            let trial = yearlyData?.item_price.trial_period || 7;
            let yearlyPrice = yearlyData?.item_price?.price || 9900


            console.log(`monthly: ${convertPrice(monthlyPrice)}`)
            console.log(`yearlyPrice: ${convertPrice(yearlyPrice)}`)
            setPlanPrices({
              monthly: convertPrice(monthlyPrice),
              yearly: convertPrice(yearlyPrice),
              trial_period: trial || 7,
              loading: false,
            });
          })
          .catch((err) => {
            setPlanPrices({ ...planPrices, loading: false });
            console.log(err);
          });
      });
  }, []);

  return (
    <div>
      <div className="purchase_sc_top">
        <div className="top_shape d_flex justify_content_center align_items_center">
          <div className="pr_logo">
            <img src={purchase_logo} alt="" />
          </div>
        </div>
      </div>
      <br />
      <h3>
        Become a calmer & <br />
        happier mama{" "}
      </h3>
      <p>Happy Moms = Happy Kids</p>
      <div className="purchase_sc_body">
        <h4>
          How Your Free <br />
          Trial Works
        </h4>
        {/* timeline  */}
        <TimeLine />
        <br />
        {/*  */}
        {/*<h3>Unlock All Features</h3>*/}
        {/*/!*  *!/*/}
        {/*<p*/}
        {/*  role="button"*/}
        {/*  onClick={toggleModal}*/}
        {/*  tabIndex="0"*/}
        {/*  className="cursor_pointer user_select_none text_primary"*/}
        {/*>*/}
        {/*  View All Plans*/}
        {/*</p>*/}
        {/* features */}
        <Features />
        {/* badge gradient card */}
        <GradientCard />
        {/*  */}
        <h4>Unlock 250+ Guided Mindpower Sessions</h4>
        <h5>Including these member favorites:</h5>
        {/* features # 2*/}
        <Features2 />
        {/* Testimonial */}
        <Testimonial />
        {/* Brands */}
        <Brands />
        {/*  */}
        {/*<h3>Unlock All Features</h3>*/}
        {/*/!*  *!/*/}
        {/*<p*/}
        {/*  role="button"*/}
        {/*  onClick={toggleModal}*/}
        {/*  tabIndex="0"*/}
        {/*  className="cursor_pointer user_select_none text_primary"*/}
        {/*>*/}
        {/*  View All Plans*/}
        {/*</p>*/}
        {/* FAQS */}
        <Faqs />
        {/* logout */}
        <button
          onClick={() => auth.signOut()}
          className="text_white hover_scale cs_btn text_decoration_none"
        >
          Logout
        </button>
        <br />
        {/* bottom fixed button */}
        <div className="purchase_bottom_card">
          <button
            data-cb-type="checkout"
            data-cb-item-0={

              searchParams.get("sId") ? `${searchParams.get("sId")}` : `${process.env.REACT_APP_CHARGEBEE_YEARLY_PRODUCT}`

          }
            data-cb-item-0-quantity="1"
            className={`cs_btn w_100
             ${selectedPlan === "Yearly" ? " " : " d_none"}
            `}
          >
            GET STARTED
            <span>with a {planPrices.trial_period} day FREE trial</span>
          </button>
          <button
            data-cb-type="checkout"
            data-cb-item-0={`${process.env.REACT_APP_CHARGEBEE_MONTHLY_PRODUCT}`}
            data-cb-item-0-quantity="1"
            className={`cs_btn w_100
              ${selectedPlan === "Monthly" ? " " : " d_none"}
              `}
          >
            GET STARTED
          </button>
          <p className="text_gray" style={{ margin: "9px auto" }}>
            {selectedPlan === "Yearly"
              ? `$${
                  planPrices?.loading ? "loading.." : planPrices.yearly
                } per year after ${planPrices.trial_period}-day FREE trial.`
              : `Just $${
                  planPrices?.loading ? "loading.." : planPrices.monthly
                } per month. Starts today`}
          </p>
          <span>{selectedPlan === "Yearly" ? `Just $${planPrices?.loading ? "loading.." : (planPrices.yearly / 12).toFixed(2)} per month` : ``}</span>
          <div className="d_flex justify_content_center align_items_center text_center">
            <a
              className="terms_link"
              href="https://www.mamazen.com/privacy-policy"
              target="_blank"
              rel="noopener noreferrer"
            >
              Privacy Policy
            </a>
            <span className="terms_link"> & </span>
            <a
              className="terms_link"
              href="https://www.mamazen.com/terms-of-service"
              target="_blank"
              rel="noopener noreferrer"
            >
              Terms of Service
            </a>
          </div>
        </div>
        {/* payment plans modal */}
        {purchaseModal ? (
          <div className="payment_select_modal">
            <div className="d_flex justify_content_end align_items_center">
              <h5
                style={{ paddingRight: "5px" }}
                className="text_blue text_uppercase"
              >
                Best Value
              </h5>
            </div>
            {/*  */}
            <button
              onClick={() => selectAPlan("Yearly")}
              className={`price_btn save ${
                selectedPlan === "Yearly" ? " selectedPkg" : ""
              }`}
              data-save="Save 62%"
            >
              <div className="price_btn_top d_flex align_items_center">
                <h5 className="text_primary">Annual</h5>
                <h5 className="price">
                  ${planPrices?.loading ? "loading.." : planPrices.yearly} /
                  year
                </h5>
              </div>
              <div className="price_btn_bottom">
                <p className="text_blue">{planPrices.trial_period} day FREE TRIAL</p>
                <span>
                  Just $
                  {(planPrices?.loading
                    ? "loading.."
                    : planPrices.yearly / 12
                  ).toFixed(2)}{" "}
                  per month
                </span>
              </div>
              {selectedPlan === "Yearly" && (
                <BlueTickIcon className={"selectedPkgItem"} />
              )}
            </button>
            <button
              onClick={() => selectAPlan("Monthly")}
              className={`price_btn ${
                selectedPlan === "Monthly" ? " selectedPkg" : ""
              }`}
            >
              <div className="price_btn_top d_flex align_items_center">
                <h5 className="text_primary">Monthly</h5>
                <h5 className="price">
                  ${planPrices?.loading ? "loading.." : planPrices.monthly} / mo
                </h5>
              </div>
              <div className="price_btn_bottom">
                <p className="text_blue">Starts Today</p>
              </div>
              {selectedPlan === "Monthly" && (
                <BlueTickIcon className={"selectedPkgItem"} />
              )}
            </button>
            {/*  */}
            {selectedPlan === "Yearly" && (
              <p className="text_gray">with a {planPrices.trial_period} day FREE trial</p>
            )}
            <div className="d_flex justify_content_center align_items_center text_center">
              <a
                className="terms_link"
                href="https://www.mamazen.com/privacy-policy"
                target="_blank"
                rel="noopener noreferrer"
              >
                Privacy Policy
              </a>
              <span className="terms_link"> & </span>
              <a
                className="terms_link"
                href="https://www.mamazen.com/terms-of-service"
                target="_blank"
                rel="noopener noreferrer"
              >
                Terms of Service
              </a>
            </div>
            <button onClick={closeModal} className="cs_btn w_100">
              Continue
            </button>
            <p className="text_gray" style={{ marginTop: "9px" }}>
              {selectedPlan === "Yearly"
                ? `$${
                    planPrices?.loading ? "loading.." : planPrices.yearly
                  } per year after ${planPrices.trial_period}-day FREE trial.`
                : `Just $${
                    planPrices?.loading ? "loading.." : planPrices.monthly
                  } per month. Starts today`}
            </p>
          </div>
        ) : null}
        {purchaseModal && (
          <div
            onClick={closeModal}
            className="payment_select_modal_backdrop"
          ></div>
        )}
      </div>
    </div>
  );
};

export default Purchase;
